(function () {
  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function initKalmeGuide(root) {
    if (!root || root.getAttribute('data-guide-ready') === 'true') return;
    root.setAttribute('data-guide-ready', 'true');

    const i18nEl = root.querySelector('[data-guide-i18n]') || document.getElementById('kalme-guide-i18n');
    const i18n = parseJson(i18nEl) || {};
    const form = root.querySelector('[data-guide-form]');
    const nextBtn = root.querySelector('[data-guide-next]');
    const ctaBtn = root.querySelector('[data-guide-cta]');
    const summary = root.querySelector('[data-guide-summary]');
    const stepLabel = root.querySelector('[data-guide-step-label]');
    const bar = root.querySelector('[data-guide-bar]');
    const fill = root.querySelector('.kalme-guide__fill');
    const sticky = root.querySelector('[data-guide-sticky]') || document.querySelector('[data-guide-sticky]');
    const stickySummary = sticky && sticky.querySelector('[data-guide-sticky-summary]');
    const stickyCta = sticky && sticky.querySelector('[data-guide-sticky-cta]');
    const productUrl = root.getAttribute('data-guide-product') || '/collections/all';
    const catalogUrl = root.getAttribute('data-guide-catalog') || '/collections/all';
    const catalogEl = root.querySelector('[data-guide-catalog]') || document.getElementById('kalme-guide-catalog');
    let catalog = parseJson(catalogEl);
    if (!Array.isArray(catalog)) catalog = [];

    if (!form || !nextBtn || !ctaBtn || !summary || !bar || !fill) return;

    const ageLabel = {
      '0-2': i18n.age_0_2 || '0–2',
      '2-3': i18n.age_2_3 || '2–3',
      '3-5': i18n.age_3_5 || '3–5',
      '5-7': i18n.age_5_7 || '5–7',
    };
    const interestLabel = {
      manipuler: i18n.interest_manipuler_word || 'hands-on',
      reflechir: i18n.interest_reflechir_word || 'think',
      creer: i18n.interest_creer_word || 'create',
      ensemble: i18n.interest_ensemble_word || 'play together',
    };

    let step = 1;
    const answers = { age: '', interest: '' };

    /* Même mapping que kalme-home.liquid. Pas de produit dédié 5–7 ans. */
    const PROFILES = {
      'livre-tissu-animaux-ferme': { ages: ['0-2'], interests: ['manipuler', 'ensemble'] },
      'chariot-de-marche-cuisine': { ages: ['0-2'], interests: ['bouger', 'ensemble', 'manipuler'] },
      'tour-apprentissage-montessori-3-en-1': { ages: ['0-2', '2-3', '3-5'], interests: ['ensemble', 'creer'] },
      'panneau-activites-mural-dauphin': { ages: ['0-2', '2-3'], interests: ['manipuler'] },
      'planche-activites-bois': { ages: ['0-2', '2-3', '3-5'], interests: ['manipuler'] },
      'coffret-boites-activites-montessori': { ages: ['0-2', '2-3'], interests: ['manipuler', 'reflechir'] },
      'labyrinthe-magnetique-tri-couleurs': { ages: ['3-5'], interests: ['manipuler', 'reflechir'] },
      'puzzle-systeme-solaire': { ages: ['3-5'], interests: ['reflechir', 'communiquer'] },
      'puzzles-systeme-solaire': { ages: ['3-5'], interests: ['reflechir'] },
      'coffret-ville-bois-115': { ages: ['3-5'], interests: ['creer', 'ensemble'] },
      'mini-etabli-bois': { ages: ['3-5'], interests: ['creer', 'manipuler'] },
      'mini-cuisine-renard': { ages: ['3-5'], interests: ['ensemble', 'creer'] },
      'chariot-de-menage-bois': { ages: ['3-5'], interests: ['ensemble', 'manipuler'] },
    };
    const AGE_NEAR = {
      '0-2': ['2-3'],
      '2-3': ['0-2', '3-5'],
      '3-5': ['2-3', '5-7'],
      '5-7': ['3-5'],
    };
    const WHY = {
      manipuler: i18n.rec_why_manipuler,
      reflechir: i18n.rec_why_reflechir,
      creer: i18n.rec_why_creer,
      ensemble: i18n.rec_why_ensemble,
    };

    function priceValue(product) {
      const raw = String((product && product.price) || '')
        .replace(/[^\d.,]/g, '')
        .replace(',', '.');
      const n = parseFloat(raw);
      return isNaN(n) ? 999 : n;
    }

    function uniq(list) {
      const seen = {};
      const out = [];
      for (let i = 0; i < list.length; i++) {
        if (!list[i] || seen[list[i]]) continue;
        seen[list[i]] = true;
        out.push(list[i]);
      }
      return out;
    }

    function inferProfile(product) {
      const tags = (product.tags || []).map(function (tag) {
        return String(tag).toLowerCase();
      });
      function has(needle) {
        return tags.some(function (tag) {
          return tag.indexOf(needle) !== -1;
        });
      }
      const ages = [];
      const interests = [];
      if (has('bebe') || has('0-2') || has('18-mois') || has('dentition')) ages.push('0-2');
      if (has('2-3') || has('18-mois')) ages.push('2-3');
      if (has('3-ans') || has('3-6') || has('3-5') || has('4-6')) {
        ages.push('3-5');
        ages.push('5-7');
      }
      if (has('5-7') || has('6-ans')) ages.push('5-7');
      if (has('motricite') || has('busy') || has('sensoriel') || has('planche') || has('permanence')) {
        interests.push('manipuler');
      }
      if (has('puzzle') || has('educatif') || has('couleurs') || has('formes')) interests.push('reflechir');
      if (has('construction') || has('ville') || has('etabli') || has('bricolage')) interests.push('creer');
      if (has('imitation') || has('cuisine') || has('dinette') || has('menage') || has('tour-apprentissage')) {
        interests.push('ensemble');
      }
      return {
        ages: uniq(ages.length ? ages : ['2-3', '3-5']),
        interests: uniq(interests.length ? interests : ['manipuler']),
      };
    }

    function profileFor(product) {
      return PROFILES[product.handle] || inferProfile(product);
    }

    function scoreProduct(product, age, interest) {
      const profile = profileFor(product);
      if (profile.ages.indexOf(age) === -1) return -1;
      let score = 10;
      if (profile.ages.length === 1) score += 5;
      const ix = profile.interests.indexOf(interest);
      if (ix === -1) score += 1;
      else {
        score += 8;
        if (ix === 0) score += 4;
      }
      return score;
    }

    function rankFor(age, interest) {
      const scored = catalog
        .map(function (product) {
          return { product: product, score: scoreProduct(product, age, interest) };
        })
        .filter(function (row) {
          return row.score >= 0;
        });
      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return priceValue(a.product) - priceValue(b.product);
      });
      return scored;
    }

    function rankedProducts(age, interest) {
      let scored = rankFor(age, interest);
      if (!scored.length) {
        const nearby = AGE_NEAR[age] || [];
        for (let i = 0; i < nearby.length && !scored.length; i++) {
          scored = rankFor(nearby[i], interest);
        }
      }
      return scored.map(function (row) {
        return row.product;
      });
    }

    function fallbackRec(echo) {
      return {
        echo: echo,
        title: i18n.rec_fallback_title,
        text: i18n.rec_fallback_text,
        href: catalogUrl || productUrl,
        cta: i18n.cta_ages,
        image: '',
        alt: '',
        price: '',
        also: [],
      };
    }

    function recommend() {
      const age = answers.age;
      const interest = answers.interest;
      const echo = (i18n.echo || 'For a child aged __age__ who likes to __interest__.')
        .replace('__age__', ageLabel[age] || '')
        .replace('__interest__', interestLabel[interest] || '');

      const ranked = rankedProducts(age, interest);
      const pick = ranked[0];
      if (!pick) return fallbackRec(echo);

      return {
        echo: echo,
        title: pick.title,
        text: WHY[interest] || i18n.rec_fallback_text,
        href: pick.url || productUrl,
        cta: i18n.cta_toy,
        image: pick.image || '',
        alt: pick.alt || pick.title,
        price: pick.price || '',
        also: ranked.slice(1, 3),
      };
    }

    function renderAlso(items) {
      const wrap = root.querySelector('[data-guide-also]');
      const list = root.querySelector('[data-guide-also-list]');
      if (!wrap || !list) return;
      list.textContent = '';
      if (!items || !items.length) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      items.forEach(function (item) {
        const link = document.createElement('a');
        link.className = 'kalme-guide__also-item';
        link.href = item.url || catalogUrl;
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.alt || item.title || '';
          img.width = 72;
          img.height = 72;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        const name = document.createElement('span');
        name.textContent = item.title || '';
        link.appendChild(name);
        list.appendChild(link);
      });
    }

    function summaryText() {
      if (step === 1) return answers.age ? ageLabel[answers.age] : i18n.start || '';
      if (step === 2) {
        if (answers.interest) return ageLabel[answers.age] + ' · ' + interestLabel[answers.interest];
        return ageLabel[answers.age] + ' · ' + (i18n.next_interest || '');
      }
      return recommend().echo;
    }

    function render() {
      root.querySelectorAll('[data-guide-panel]').forEach(function (panel) {
        const on = Number(panel.getAttribute('data-guide-panel')) === step;
        panel.hidden = !on;
        panel.classList.toggle('is-on', on);
      });

      if (stepLabel) {
        stepLabel.textContent = (i18n.step_of || 'Step __current__ of 3').replace('__current__', String(step));
      }
      bar.setAttribute('aria-valuenow', String(step));
      fill.style.transform = 'scaleX(' + step / 3 + ')';
      summary.textContent = summaryText();

      const ready = (step === 1 && answers.age) || (step === 2 && answers.interest) || step === 3;
      nextBtn.disabled = !ready || step === 3;
      nextBtn.hidden = step === 3;
      ctaBtn.hidden = step !== 3;

      if (step === 3) {
        const rec = recommend();
        const pick = root.querySelector('[data-guide-pick]');
        const pickImg = root.querySelector('[data-guide-pick-img]');
        const pickPrice = root.querySelector('[data-guide-pick-price]');
        root.querySelector('[data-guide-echo]').textContent = rec.echo;
        root.querySelector('[data-guide-result-title]').textContent = rec.title;
        root.querySelector('[data-guide-result-text]').textContent = rec.text;
        if (pick) pick.href = rec.href;
        if (pickImg) {
          if (rec.image) {
            pickImg.src = rec.image;
            pickImg.alt = rec.alt || rec.title || '';
            pickImg.hidden = false;
          } else {
            pickImg.removeAttribute('src');
            pickImg.alt = '';
            pickImg.hidden = true;
          }
        }
        if (pickPrice) {
          pickPrice.textContent = rec.price || '';
          pickPrice.hidden = !rec.price;
        }
        renderAlso(rec.also);
        ctaBtn.href = rec.href;
        ctaBtn.textContent = rec.cta;
        if (stickyCta) {
          stickyCta.href = rec.href;
          stickyCta.textContent = rec.cta;
        }
      } else if (stickyCta) {
        stickyCta.href = '#guide';
        stickyCta.textContent = i18n.resume || '';
      }

      if (stickySummary) stickySummary.textContent = summaryText();
      updateSticky();
    }

    function updateSticky() {
      if (!sticky) return;
      const started = Boolean(answers.age);
      const rect = root.getBoundingClientRect();
      const off = rect.bottom < 80 || rect.top > window.innerHeight - 40;
      const show = started && off;
      sticky.hidden = !show;
      sticky.classList.toggle('is-on', show);
    }

    form.addEventListener('change', function (event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      answers[input.name] = input.value;
      input.closest('.kalme-guide__choice') &&
        root.querySelectorAll('input[name="' + input.name + '"]').forEach(function (el) {
          el.closest('.kalme-guide__choice').classList.toggle('is-picked', el.checked);
        });
      render();
    });

    nextBtn.addEventListener('click', function () {
      if (step === 1 && !answers.age) return;
      if (step === 2 && !answers.interest) return;
      if (step < 3) step += 1;
      render();
      const panel = root.querySelector('[data-guide-panel="' + step + '"] legend');
      if (panel) panel.focus({ preventScroll: true });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-kalme-guide]').forEach(initKalmeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
